/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Test_Notification_BodyInputs */

const th_test_notification_body = /** @type {(inputs: Test_Notification_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`นี่คือลักษณะการแจ้งเตือนคะแนนสด`)
};

const en_test_notification_body = /** @type {(inputs: Test_Notification_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This is what a live score will look like.`)
};

const ja_test_notification_body = /** @type {(inputs: Test_Notification_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ライブスコアの通知はこのように表示されます。`)
};

const zh_test_notification_body = /** @type {(inputs: Test_Notification_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`实时比分看起来就是这样。`)
};

const es_test_notification_body = /** @type {(inputs: Test_Notification_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Así se verá un resultado en directo.`)
};

const pt_test_notification_body = /** @type {(inputs: Test_Notification_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`É assim que um placar ao vivo vai aparecer.`)
};

const id_test_notification_body = /** @type {(inputs: Test_Notification_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beginilah tampilan skor langsung nanti.`)
};

const fr_test_notification_body = /** @type {(inputs: Test_Notification_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voici à quoi ressemblera un score en direct.`)
};

const tl_test_notification_body = /** @type {(inputs: Test_Notification_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ganito ang magiging hitsura ng live na iskor.`)
};

const vi_test_notification_body = /** @type {(inputs: Test_Notification_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Một tỉ số trực tiếp sẽ trông như thế này.`)
};

const ko_test_notification_body = /** @type {(inputs: Test_Notification_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`실시간 점수는 이렇게 보입니다.`)
};

const de_test_notification_body = /** @type {(inputs: Test_Notification_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`So wird ein Live-Ergebnis aussehen.`)
};

const ru_test_notification_body = /** @type {(inputs: Test_Notification_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вот так будет выглядеть счёт в прямом эфире.`)
};

const tr_test_notification_body = /** @type {(inputs: Test_Notification_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Canlı bir skor böyle görünecek.`)
};

const it_test_notification_body = /** @type {(inputs: Test_Notification_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ecco come apparirà un punteggio in diretta.`)
};

const pl_test_notification_body = /** @type {(inputs: Test_Notification_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tak będzie wyglądał wynik na żywo.`)
};

const uk_test_notification_body = /** @type {(inputs: Test_Notification_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ось так виглядатиме рахунок у прямому ефірі.`)
};

const hi_test_notification_body = /** @type {(inputs: Test_Notification_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`लाइव स्कोर ऐसा दिखेगा।`)
};

const ar_test_notification_body = /** @type {(inputs: Test_Notification_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`هكذا ستبدو النتيجة المباشرة.`)
};

const ms_test_notification_body = /** @type {(inputs: Test_Notification_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beginilah rupa mata langsung nanti.`)
};

const bn_test_notification_body = /** @type {(inputs: Test_Notification_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`সরাসরি স্কোর দেখতে এমনই লাগবে।`)
};

const zh_tw2_test_notification_body = /** @type {(inputs: Test_Notification_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`即時比分看起來就是這樣。`)
};

const zh_hk2_test_notification_body = /** @type {(inputs: Test_Notification_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`即時比分看起來就是這樣。`)
};

const ur_test_notification_body = /** @type {(inputs: Test_Notification_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`براہ راست اسکور ایسا دکھائی دے گا۔`)
};

const fa_test_notification_body = /** @type {(inputs: Test_Notification_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`نتیجهٔ زنده این‌گونه دیده می‌شود.`)
};

const sw_test_notification_body = /** @type {(inputs: Test_Notification_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hivi ndivyo matokeo ya moja kwa moja yatakavyoonekana.`)
};

const nl_test_notification_body = /** @type {(inputs: Test_Notification_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zo gaat een live stand eruitzien.`)
};

/**
* | output |
* | --- |
* | "This is what a live score will look like." |
*
* @param {Test_Notification_BodyInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const test_notification_body = /** @type {((inputs?: Test_Notification_BodyInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Test_Notification_BodyInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_test_notification_body(inputs)
	if (locale === "ja") return ja_test_notification_body(inputs)
	if (locale === "zh") return zh_test_notification_body(inputs)
	if (locale === "es") return es_test_notification_body(inputs)
	if (locale === "pt") return pt_test_notification_body(inputs)
	if (locale === "id") return id_test_notification_body(inputs)
	if (locale === "fr") return fr_test_notification_body(inputs)
	if (locale === "tl") return tl_test_notification_body(inputs)
	if (locale === "vi") return vi_test_notification_body(inputs)
	if (locale === "ko") return ko_test_notification_body(inputs)
	if (locale === "de") return de_test_notification_body(inputs)
	if (locale === "ru") return ru_test_notification_body(inputs)
	if (locale === "tr") return tr_test_notification_body(inputs)
	if (locale === "it") return it_test_notification_body(inputs)
	if (locale === "pl") return pl_test_notification_body(inputs)
	if (locale === "uk") return uk_test_notification_body(inputs)
	if (locale === "hi") return hi_test_notification_body(inputs)
	if (locale === "ar") return ar_test_notification_body(inputs)
	if (locale === "ms") return ms_test_notification_body(inputs)
	if (locale === "bn") return bn_test_notification_body(inputs)
	if (locale === "zh-TW") return zh_tw2_test_notification_body(inputs)
	if (locale === "zh-HK") return zh_hk2_test_notification_body(inputs)
	if (locale === "ur") return ur_test_notification_body(inputs)
	if (locale === "fa") return fa_test_notification_body(inputs)
	if (locale === "sw") return sw_test_notification_body(inputs)
	if (locale === "nl") return nl_test_notification_body(inputs)
	return en_test_notification_body(inputs)
});